import { Box, Typography } from "@avenue-8/sidekick-ui";
import styled from "@emotion/styled";

export const Text = styled(Typography)`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0.25rem;
  font-size: ${(p) => p.theme.text.fontSizes.l};

  a {
    text-decoration: none;
    &:hover {
      text-decoration: underline;
    }
  }
`;

export const ContactInfoItem = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 0.25rem;
  text-align: center;
`;

export const TeamCard = styled.div`
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  justify-content: center;
  align-items: center;
  gap: 0.5rem;
  padding: 2rem;
  border-radius: 0.5rem;
  border: 1px solid ${(p) => p.theme.colors.border2};
  background-color: ${(p) => p.theme.colors.background};
  width: 100%;
  max-width: 780px;
  margin: auto;
  min-height: 220px;
`;

export const SectionEditWrapper = styled.div`
  position: relative;
  border-radius: 0.5rem;
  padding: 3rem 2rem;

  .top-bar-container {
    opacity: 0;
    transition: opacity 0.2s ease-in-out;
  }

  &:hover .top-bar-container {
    opacity: 1;
  }
`;

export const TopBarContainer = styled.div`
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  top: -0.5rem;
  left: 2rem;
  right: 2rem;
  padding: 0 0.5rem 0 1rem;
  z-index: 2;
`;

export const ActionsContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;

export const TeamLogoContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;

  img {
    max-width: 220px;
    width: 100%;
    height: auto;
    object-fit: contain;
    max-height: 200px;
  }

  p {
    font-size: 1.25rem;
    font-weight: 500;
  }

  @media (max-width: 640px) {
    text-align: center;
  }
`;
